import Header from '@components/Header';
import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CouponBarcode from './components/CouponBarcode';
import CouponInfo from './components/CouponInfo';
import CouponNote from './components/CouponNote';
import PreventCapture from './components/PreventCapture';
import useMyCoupon from './hooks/useMyCoupon';

interface Params {
    couponId: string;
}

const CouponDetailActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { couponId } = params;
    const { coupon, isLoading } = useMyCoupon(couponId);
    const { t } = useTranslation('coupon');

    return (
        <AppScreen>
            <Header title={t('detail.title')} />
            {isLoading && (<Loading/>)}
            {coupon && (
                <Fragment>
                    <CouponInfo coupon={coupon}/>
                    {coupon.status === 'ISSUED' && (
                        <Fragment>
                            <CouponBarcode couponNo={coupon.couponNo}/>
                            <PreventCapture/>
                        </Fragment>
                    )}
                    <CouponNote note={coupon.note}/>
                </Fragment>
            )}
        </AppScreen>
    );
};

export default CouponDetailActivity;
